import React from 'react';
import { BrowserRouter, Routes, Route, NavLink, Navigate, Link } from 'react-router-dom';
import { AppProvider, useApp } from './context/AppContext';
import LandingPage from './pages/LandingPage';
import { LoginPage, RegisterPage } from './pages/AuthPages';
import ProfilePage from './pages/ProfilePage';
import PartnerPage from './pages/PartnerPage';
import OfferPage from './pages/OfferPage';
import SupportWidget from './components/SupportWidget';
import './index.css';

function BrandMark() {
  return (
    <NavLink to="/" className="nav-brand" aria-label="SBPUSDT — на главную">
      <span className="brand-orbit" aria-hidden="true">
        <span className="brand-leaf" />
      </span>
      <span className="brand-name">SBP<span>USDT</span></span>
    </NavLink>
  );
}

function Layout({ children }: { children: React.ReactNode }) {
  const { userAuth } = useApp();

  return (
    <div className="app">
      <nav className="nav">
        <BrandMark />
        <div className="nav-links">
          <NavLink to="/" end className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
            Кабинет
          </NavLink>
          <NavLink to="/profile" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
            Профиль
          </NavLink>
          <NavLink to="/partner" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
            Партнёры
          </NavLink>
          {userAuth.token && (
            <button type="button" className="nav-link nav-logout" onClick={userAuth.logout}>
              Выйти
            </button>
          )}
        </div>
      </nav>
      <main className="main">{children}</main>
      <footer className="site-footer">
        <div className="footer-mark" aria-hidden="true">↗</div>
        <div>
          <span>
            Техническая интеграция платёжной инфраструктуры осуществляется через Bitbanker KG на основании оферты.
          </span>
          {' '}
          <Link to="/offer">
            Публичная оферта Bitbanker KG
          </Link>
        </div>
      </footer>
      <SupportWidget />
    </div>
  );
}

export default function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/admin/*" element={<Navigate to="/" replace />} />
            <Route path="/partner" element={<PartnerPage />} />
            <Route path="/offer" element={<OfferPage />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </AppProvider>
  );
}
